/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Fri Dec 21 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

class CurriculumConsoleController {
    constructor($scope, $rootScope, authService, localStorageService, $state, $mdDialog, $location, $anchorScroll) {
        'ngInject';
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Curriculum Console"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        var ctrl = this;
        ctrl.minDate = new Date()
        ctrl.selectedSessions = [];
        let sessionsArry = [];
        ctrl.enableNextBtn = false;
        ctrl.showSessBtn = false;
        this.addedSessions = []
        ctrl.initialSettingId = 0;
        $scope.showWizard = false;
        this.errors = {}
        let schoolId = localStorageService.get('school_id')

        $scope.getList = function () {
            authService.callAPI("/v0/initial-settings/curriculum-console/academic/" + schoolId, "GET", null, function (response) {
                try {
                    ctrl.acdConsole = response.result.data.data.academicConsoleData
                    ctrl.fullSettings = response.result.data.data.settingsData
                    let addedSessions = ctrl.acdConsole
                    let allSettings = angular.copy(ctrl.fullSettings)

                    if (addedSessions) {
                        ctrl.addedSessions = _.pluck(addedSessions, 'session_id')
                    }

                    let alreadyAddedSessions = ctrl.addedSessions
                    ctrl.sessionPackage = _.find(ctrl.fullSettings, function (sess) {
                        return sess.type == 'session'
                    })

                    if (ctrl.sessionPackage) {
                        ctrl.sessionPackage.list = _.filter(ctrl.sessionPackage.list, function (sess) {
                            return alreadyAddedSessions.indexOf(sess._id) === -1
                        })
                        ctrl.sessionPackage.list = _.uniq(ctrl.sessionPackage.list, function (doc) {
                            return doc._id
                        });
                    }
                    ctrl.curriculumPackage = _.filter(ctrl.fullSettings, function (sess) {
                        return sess.type == 'curriculum'
                    })

                    ctrl.getSession(allSettings);
                    ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                } catch (e) {
                    console.log(e);
                }
                $scope.$apply()
            })
        }

        $scope.getList()

        $scope.btnLabel = "Save";

        this.editMe = (newsession) => {
            this.currentEditSession = newsession._id
            let session = angular.copy(newsession)
            this.sessionToEdit = session
            let timeObjStart = converTimeBack(session.start_time)
            let timeObjEnd = converTimeBack(session.end_time)
            if (timeObjStart) {
                this.sessionToEdit.hh = timeObjStart.hh
                this.sessionToEdit.mm = timeObjStart.mm
                this.sessionToEdit.mer = timeObjStart.mer
                this.sessionToEdit.hhEnd = timeObjEnd.hh
                this.sessionToEdit.mmEnd = timeObjEnd.mm
                this.sessionToEdit.merEnd = timeObjEnd.mer
            }
            this.sessionToEdit.curriculum = _.pluck(session.curriculum, "_id")
            this.editMode = true
            $location.hash('top');
            $anchorScroll();
        }

        this.updateSession = () => {
            validateSessionUpdate()
            if (Object.keys(this.errors).length > 0) {
                return false
            }

            let requestBody = {
                sessions: [this.sessionToEdit],
                settingId: ctrl.sessionPackage._id,
                school_id: schoolId
            }

            authService.callAPI("/v0/initial-settings/curriculum-console/add", "POST", requestBody, function (response) {
                if (response && response.result) {
                    ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                    ctrl.selectedSessions = [];
                    ctrl.cancelEdit()
                    $scope.getList()
                    toastr.success("Updated successfully!");
                } else {
                    try {
                        console.log(response.error);
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                $scope.$apply()
            })
        }

        let editTimeValidate = (timeObj, sessionObj) => {

            let startHours = parseInt(timeObj.hh)
            let startMinutes = parseInt(timeObj.mm)
            let startMeridian = timeObj.mer
            let endHours = parseInt(timeObj.hhEnd)
            let endMinutes = parseInt(timeObj.mmEnd)
            let endMeridian = timeObj.merEnd
            if (startMeridian == 'PM' && startHours != 12) {
                startHours += 12
            }
            if (endMeridian == 'PM' && endHours != 12) {
                endHours += 12
            }

            if (endMeridian == 'AM' && endHours == 12) {
                endHours = 0
            }
            if (startMeridian == 'AM' && startHours == 12) {
                startHours = 0
            }
            let d = new Date(1991, '04', '01', startHours, startMinutes, '00', '000');
            let dEnd = new Date(1991, '04', '01', endHours, endMinutes, '00', '000');
            if (d >= dEnd) {
                return false
            }
            sessionObj.start_time = d
            sessionObj.end_time = dEnd
            return true
        }

        let validateSessionUpdate = (obj) => {
            this.errors = {}
            if (!this.sessionToEdit.hh || this.sessionToEdit.hh == '') {
                this.errors['editStart'] = 'start time hours required'
            } else if (!this.sessionToEdit.mm || this.sessionToEdit.mm == '') {
                this.errors['editStart'] = 'start time minutes required'
            } else if (!this.sessionToEdit.mer || this.sessionToEdit.mer == '') {
                this.errors['editStart'] = 'start time meridian required'
            } else {
                delete this.errors['editStart']
            }
            if (!this.sessionToEdit.hhEnd || this.sessionToEdit.hhEnd == '') {
                this.errors['editEnd'] = 'end time hours required'
            } else if (!this.sessionToEdit.mmEnd || this.sessionToEdit.mmEnd == '') {
                this.errors['editEnd'] = 'end time minutes required'
            } else if (!this.sessionToEdit.merEnd || this.sessionToEdit.merEnd == '') {
                this.errors['editEnd'] = 'end time meridian required'
            } else if (!editTimeValidate(this.sessionToEdit, this.sessionToEdit)) {
                this.errors['editEnd'] = 'end time should be after start time'
            } else {
                delete this.errors['editEnd']
            }
            if (!this.sessionToEdit.curriculum || this.sessionToEdit.curriculum == '' || this.sessionToEdit.curriculum.length <= 0) {
                this.errors['editCurriculum'] = 'curriculum required'
            } else {
                delete this.errors['editCurriculum']
            }
        }

        let validateSessionCreate = () => {
            ctrl.errors.iscreateError = false
            this.errors = {}
            let count = 0
            this.errors.create = []

            _.each(ctrl.selectedSessions, function (sess) {
                if (!ctrl.errors.create[count]) {
                    ctrl.errors.create[count] = {}
                }
                if (!sess.curriculum || sess.curriculum.length <= 0) {
                    ctrl.errors.create[count].curriculum = 'curriculum required'
                } else {
                    delete ctrl.errors.create[count].curriculum
                }
                if (!sess.hh || sess.hh == null) {
                    ctrl.errors.create[count].start_time = 'start time hours required'
                } else if (!sess.mm || sess.mm == null) {
                    ctrl.errors.create[count].start_time = 'start time minutes required'
                } else if (!sess.mer || sess.mer == null) {
                    ctrl.errors.create[count].start_time = 'start time meridian required'
                } else {
                    delete ctrl.errors.create[count].start_time
                }

                if (!sess.hhEnd || sess.hhEnd == null) {
                    ctrl.errors.create[count].end_time = 'end time hours required'
                } else if (!sess.mmEnd || sess.mmEnd == null) {
                    ctrl.errors.create[count].end_time = 'end time minutes required'
                } else if (!sess.merEnd || sess.merEnd == null) {
                    ctrl.errors.create[count].end_time = 'end time hours required'
                } else if (!editTimeValidate(sess, sess)) {
                    ctrl.errors.create[count].end_time = 'end time should be after start time'
                } else {
                    delete ctrl.errors.create[count].end_time
                }
                if (Object.keys(ctrl.errors.create[count]).length !== 0) {
                    ctrl.errors.iscreateError = true
                }
                count++

            })

            if (ctrl.errors.create.length === 0) {
                delete ctrl.errors.create
            }
        }

        this.cancelEdit = () => {
            this.editMode = false
            this.currentEditSession = false
            this.sessionToEdit = {}
        }

        this.getSession = function (allSettings) {
            ctrl.curriculumList = [];

            let sessionIds = ctrl.acdConsole

            ctrl.curriculumList = ctrl.curriculumPackage[0].list
            sessionsArry = _.uniq(_.pluck(sessionIds, 'session_id'))

            ctrl.sessionsNames = [];

            let sessionData = _.find(allSettings, function (sess) {
                return sess.type == "session"
            })

            _.each(sessionsArry, function (data2) {
                var sessionDataSet = _.find(sessionData.list, function (sess) {
                    return sess._id == data2
                })

                ctrl.sessionsNames.push(sessionDataSet);
            })

            ctrl.sessionsDetails = []
            var i = 0
            _.each(ctrl.sessionsNames, function (data3) {
                if (!data3) {
                    data3 = {}
                }
                data3.curriculum = [];
                let curriculumData = _.filter(ctrl.acdConsole, function (one) {
                    return one.session_id == data3._id
                })



                var j = 0
                _.each(curriculumData, function (data4) {
                    let curriculumDetails = _.find(allSettings, function (oneS) {
                        return _.find(oneS.list, function (two) {
                            return two._id == data4.curriculum_id
                        })
                    })
                    var curriculumDataSet = _.find(curriculumDetails.list, function (curr) {
                        return curr._id == data4.curriculum_id
                    })
                    data3.curriculum[j] = curriculumDataSet;
                    j++
                })
                ctrl.sessionsDetails.push(data3);
                i++
            });
            ctrl.sessionsLength = ctrl.sessionsDetails.length;
        }

        ctrl.dragControlListeners = {
            //optional param
            containment: '#blocks'
        };

        ctrl.sortableCloneOptions1 = {
            containment: '#sortable-container',
            allowDuplicates: true,
            ctrlClone: true,
            dragEnd: function (obj) {
                for (var i = 0; i < ctrl.sessionPackage.list.length; i++) {
                    var data = {
                        _id: ctrl.sessionPackage.list[i]._id,
                        end_time: ctrl.sessionPackage.list[i].end_time,
                        name: ctrl.sessionPackage.list[i].name,
                        start_time: ctrl.sessionPackage.list[i].start_time
                    }
                    ctrl.sessionPackage.list[i] = undefined;
                    ctrl.sessionPackage.list[i] = data;
                }
            }
        };

        ctrl.showSessions = function () {
            ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
        }

        ctrl.getcurriculum = (id) => {
            ctrl.showSessBtn = true;
        }

        ctrl.saveSession = function () {
            validateSessionCreate()

            if (ctrl.errors.iscreateError) {
                return false
            }

            let requestBody = {
                sessions: ctrl.selectedSessions,
                settingId: ctrl.sessionPackage._id,
                school_id: schoolId
            }

            authService.callAPI("/v0/initial-settings/curriculum-console/add", "POST", requestBody, function (response) {
                if (response && response.result) {
                    ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                    ctrl.selectedSessions = [];
                    $scope.getList()
                    toastr.success("Updated successfully!");
                } else {
                    try {
                        console.log(response.error);
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                $scope.$apply()
            })
        }


        function checkPreviouslyAssignedCirriculumToUser(id) {

            let requestBody = {
                id: id,
                settinsCurr: ctrl.curriculumPackage[0].list
            }
            authService.callAPI("/v0/initial-settings/curriculum-console/check/assigned-or-not", "POST", requestBody, function (response) {
                console.log(response);
                if (response && response.result) {
                    try {
                        showPopupforDeleteAction(response.result.data.details.no_of_users, id);
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    try {
                        console.log(response.error);
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                $scope.$apply()
            })
        }

        function showPopupforDeleteAction(no_of_users, id) {
            if (no_of_users > 0) {
                $mdDialog.show(
                    $mdDialog.alert()
                        .parent(angular.element(document.querySelector('#popupContainer')))
                        .clickOutsideToClose(true)
                        .title('Warning')
                        .textContent('Cannot delete. Users are already assigned')
                        .ariaLabel('Alert Dialog Demo')
                        .ok('Ok')
                        .targetEvent()
                );
                return false
            } else {
                let delete_toast_msg = 'You will loose previously added session info, if any.'
                var confirm = $mdDialog.confirm()
                    .title('Are you sure?')
                    .textContent(delete_toast_msg)
                    .ariaLabel('Confirm delete')
                    .ok('Yes')
                    .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    let requestBody = {
                        sessionId: id,
                        school_id: schoolId
                    }
                    authService.callAPI("/v0/initial-settings/curriculum-console/delete", "DELETE", requestBody, function (response) {
                        if (response && response.result) {
                            try {
                                ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                                ctrl.selectedSessions = [];
                                ctrl.cancelEdit();
                                $scope.getList()
                                toastr.success("Deleted successfully!");
                            } catch (ex) {
                                console.log(ex);
                            }
                        } else {
                            try {
                                console.log(response.error);
                            } catch (ex) {
                                console.log(ex);
                            }
                        }
                        $scope.$apply()
                    })
                })
            }
        }

        ctrl.removeSession = (id) => {
            if (id != this.currentEditSession)
                checkPreviouslyAssignedCirriculumToUser(id);
            else
                toastr.error("Same session is taken to edit mode");
        }

        ctrl.deleteSession = function (pkg) {
            ctrl.sessionPackage.list.push(pkg)
            ctrl.selectedSessions.remove(pkg._id);
        }

        Array.prototype.remove = function (value) {
            this.splice(this.indexOf(value), 1);
            return true;
        };

        $scope.getTime = (curPkg) => {
            curPkg.start_time = new Date(curPkg.start_time);
            curPkg.end_time = new Date(curPkg.end_time);
        }

        let converTimeBack = (time) => {
            if (time) {
                time = time.trim();
                time = new Date(time)
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let meridian = (hours > 11) ? "PM" : "AM";
                if (hours > 12) {
                    hours -= 12
                    // meridian = "PM"
                } else if (hours === 0) {
                    hours = 12
                }
                if (hours < 10) {
                    hours = "0" + hours
                }
                if (minutes < 10) {
                    minutes = "0" + minutes
                }

                return {
                    hh: hours,
                    mm: minutes,
                    mer: meridian
                }
            }

        }

        this.goNext = function () {

            if ($scope.btnLabel === "Next") {
                Meteor.call("updateInitialSettingValue", 2, function (error, result) {
                    toastr.success("Successfully saved!");
                    $state.go("academicConsole")
                });

            } else {
                toastr.success("Updated successfully!");
                $state.go("initialSetting")
            }
        }
        ctrl.hours = []
        ctrl.minutes = []

        for (let i = 0; i < 60; i++) {
            let time = i < 10 ? '0' + i : i
            ctrl.minutes.push(time)
        }

        for (let i = 1; i < 60; i++) {
            let htime = i < 10 ? '0' + i : i
            if (i < 13) {
                ctrl.hours.push(htime)
            }

        }

        this.$onDestroy = () => {
            self.hours = []
            self.minutes = []
            self.sessionPackage = undefined
            self.curriculumPackage = undefined
            self.sessionsDetails = undefined
        }
    }
}

export default CurriculumConsoleController;



// WEBPACK FOOTER //
// ./src/app/initialSettings/curriculumConsole/controllers/curriculumConsoleController.js